import { css } from 'styled-components';
import token from 'styled-token';
import { StyledAdornment } from '../../components/Adornment/Adornment.styles';
import { StyledAdornmentLeft } from '../../components/AdornmentLeft/AdornmentLeft.styles';
import { StyledAdornmentRight } from '../../components/AdornmentRight/AdornmentRight.styles';
import { StyledInput } from '../../components/Input/Input.styles';
import { autofillBackgroundMixin } from '../autofillBackgroundMixin';
import { disabledMixin } from '../disabledMixin';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
var leftCSS = function leftCSS(props) {
  return props.leftAdornment ? token({
    paddingLeft: 'Adornment.Left.paddingLeft',
    borderLeft: 'Adornment.Left.borderLeft',
    borderTopLeftRadius: 'Adornment.Left.borderTopLeftRadius',
    borderBottomLeftRadius: 'Adornment.Left.borderBottomLeftRadius'
  }, function (_ref) {
    var _ref$paddingLeft = _ref.paddingLeft,
      paddingLeft = _ref$paddingLeft === void 0 ? 0 : _ref$paddingLeft,
      _ref$borderLeft = _ref.borderLeft,
      borderLeft = _ref$borderLeft === void 0 ? 0 : _ref$borderLeft,
      _ref$borderTopLeftRad = _ref.borderTopLeftRadius,
      borderTopLeftRadius = _ref$borderTopLeftRad === void 0 ? 0 : _ref$borderTopLeftRad,
      _ref$borderBottomLeft = _ref.borderBottomLeftRadius,
      borderBottomLeftRadius = _ref$borderBottomLeft === void 0 ? 0 : _ref$borderBottomLeft;
    return css(["> ", "{padding-left:", "px;border-left:", ";border-top-left-radius:", "px;border-bottom-left-radius:", "px;}"], StyledInput, paddingLeft, borderLeft, borderTopLeftRadius, borderBottomLeftRadius);
  })(props) : '';
};
var rightCSS = function rightCSS(props) {
  return props.rightAdornment ? token({
    paddingRight: 'Adornment.Right.paddingRight',
    borderRight: 'Adornment.Right.borderRight',
    borderTopRightRadius: 'Adornment.Right.borderTopRightRadius',
    borderBottomRightRadius: 'Adornment.Right.borderBottomRightRadius'
  }, function (_ref2) {
    var _ref2$paddingRight = _ref2.paddingRight,
      paddingRight = _ref2$paddingRight === void 0 ? 0 : _ref2$paddingRight,
      _ref2$borderRight = _ref2.borderRight,
      borderRight = _ref2$borderRight === void 0 ? 0 : _ref2$borderRight,
      _ref2$borderTopRightR = _ref2.borderTopRightRadius,
      borderTopRightRadius = _ref2$borderTopRightR === void 0 ? 0 : _ref2$borderTopRightR,
      _ref2$borderBottomRig = _ref2.borderBottomRightRadius,
      borderBottomRightRadius = _ref2$borderBottomRig === void 0 ? 0 : _ref2$borderBottomRig;
    return css(["> ", "{padding-right:", "px;border-right:", ";border-top-right-radius:", "px;border-bottom-right-radius:", "px;}"], StyledInput, paddingRight, borderRight, borderTopRightRadius, borderBottomRightRadius);
  })(props) : '';
};
var errorCSS = function errorCSS(props) {
  var error = props.error;
  if (!error) {
    return '';
  }
  return token('Input.borderColorError', function (borderColor) {
    return css(["> ", "{&,&:hover:not([disabled]),&:active:not([disabled]),&:focus{& ~ ", "{border-color:", ";}}}"], StyledInput, StyledAdornment, borderColor);
  })(props);
};
var readOnlyLeftCSS = function readOnlyLeftCSS(props) {
  var leftAdornment = props.leftAdornment,
    readOnly = props.readOnly;
  if (!readOnly || !leftAdornment) {
    return '';
  }
  return css(["", "{padding-right:", ";}"], StyledAdornmentLeft, spaceMixin('sm')(props));
};
var readOnlyRightCSS = function readOnlyRightCSS(props) {
  var rightAdornment = props.rightAdornment,
    readOnly = props.readOnly;
  if (!readOnly || !rightAdornment) {
    return '';
  }
  return css(["", "{padding-left:", ";}"], StyledAdornmentRight, spaceMixin('sm')(props));
};

/** @class AdornedInputMixin */
/** @method */
export var AdornedInputMixin = function AdornedInputMixin(props) {
  var fluid = props.fluid;
  return token({
    backgroundColor: 'Input.backgroundColor',
    backgroundColorAutofill: 'Input.backgroundColorAutofill',
    backgroundColorInteractive: 'Input.backgroundColorInteractive',
    borderColorInteractive: 'Input.borderColorInteractive',
    borderColor: 'Input.borderColor',
    borderRadius: 'Adornment.borderRadius',
    focusBoxShadow: 'Adornment.boxShadow.focus',
    readOnlyBackgroundColor: 'Adornment.ReadOnly.backgroundColor',
    readOnlyBorderColor: 'Adornment.ReadOnly.borderColor'
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
      backgroundColorAutofill = _ref3.backgroundColorAutofill,
      backgroundColorInteractive = _ref3.backgroundColorInteractive,
      borderColorInteractive = _ref3.borderColorInteractive,
      borderColor = _ref3.borderColor,
      borderRadius = _ref3.borderRadius,
      focusBoxShadow = _ref3.focusBoxShadow,
      readOnlyBackgroundColor = _ref3.readOnlyBackgroundColor,
      readOnlyBorderColor = _ref3.readOnlyBorderColor;
    return css(["display:", ";> ", "{flex:0 0 auto;}> ", "{order:-1;}> ", "{min-width:0;&:-webkit-autofill ~ ", "{", "}&.edge-autofilled ~ ", "{background-color:", ";}&:active:not([disabled]),&:focus{& ~ ", "{background-color:", ";}}&:hover:not([disabled]),&:active:not([disabled]),&:focus{& ~ ", "{border-color:", ";}}&:focus{box-shadow:none;}&:focus:-webkit-autofill{", "}&[disabled] ~ ", "{", " &,&:hover,&:active,&:focus{background-color:", ";border-color:", ";}}&[readonly],&[readonly]:hover,&[readonly]:active,&[readonly]:focus{& ~ ", "{background-color:", ";border-color:", ";}}}&:focus-within{border-radius:", "px;box-shadow:", ";}", " ", " ", " ", " ", " ", ""], fluid ? 'flex' : 'inline-flex', StyledAdornment, StyledAdornmentLeft, StyledInput, StyledAdornment, autofillBackgroundMixin(props), StyledAdornment, backgroundColorAutofill, StyledAdornment, backgroundColorInteractive, StyledAdornment, borderColorInteractive, autofillBackgroundMixin(props), StyledAdornment, disabledMixin(Object.assign({}, props, {
      disabled: true
    })), backgroundColor, borderColor, StyledAdornment, readOnlyBackgroundColor || 'transparent', readOnlyBorderColor || 'transparent', borderRadius, focusBoxShadow, spacingMixin(props), leftCSS(props), rightCSS(props), errorCSS(props), readOnlyLeftCSS(props), readOnlyRightCSS(props));
  });
};